// src/api/teacherPermissions.js
import api from "./axios"; // ⚠️ عدّل المسار ده لو ملف الـ axios instance بتاعك اسمه مختلف

export const teacherPermissionsAPI = {
  list: (teacherId) =>
    api.get(`/auth/teachers/${teacherId}/permissions/`).then((r) => r.data),

  set: (teacherId, module, categoryIds = []) =>
    api
      .post(`/auth/teachers/${teacherId}/permissions/`, {
        module,
        category_ids: categoryIds,
      })
      .then((r) => r.data),

  remove: (teacherId, module, categoryId = null) =>
    api
      .delete(`/auth/teachers/${teacherId}/permissions/${module}/`, {
        params: categoryId ? { category_id: categoryId } : undefined,
      })
      .then((r) => r.data),

  moduleCategories: (module) =>
    api
      .get(`/auth/teachers/permission-categories/`, { params: { module } })
      .then((r) => r.data),

  myPermissions: () =>
    api.get(`/auth/teacher/me/permissions/`).then((r) => r.data),
};